module.exports = __webpack_public_path__ + "static/quote_request_form-a1b80c2edd25bf41e85653d3ba0147c7.png";